import TopMenuIcon from './TopMenuIcon';

export default TopMenuIcon;
